<div class="profile-page bg-secondary">
    <main class="pt-4">
        <div class="container wow fadeIn">
            <legend>Agents Product Discounts</legend>
            <!--Grid row-->
            <div class="row">
                <div class="table-responsive">
                    <b-table striped hover :items="items" :fields="fields">
                        <template #cell(agentFeeFixed)="data">
                            <span v-if="data.item.agentFeeFixed > 0">R{{data.item.agentFeeFixed}}</span>
                            <span v-else>--</span>
                        </template>
                        <template #cell(agentFeePercentage)="data">
                            <span>{{data.item.agentFeePercentage}}%</span>
                        </template>
                    </b-table>
                </div>
            </div>
            <!--Grid row-->
        </div>
    </main>
    <!--Main layout-->
</div>